export default "__VITE_ASSET__fiNg7eUM__"